import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

// eslint-disable-next-line import/prefer-default-export
export async function getConfigAiTutor(courseId) {
  const url = new URL(`${getConfig().LMS_BASE_URL}/api/ai_tutor/config/${courseId}/`);

  let response;

  try {
    response = await getAuthenticatedHttpClient().get(url);
  } catch (error) {
    const httpErrorStatus = error?.response?.status;
    if (httpErrorStatus === 403) {
      return {};
    }
    throw error;
  }

  return response.data;
}

export async function postAiTutorEvent({ formData, courseId }) {
  const url = new URL(`${getConfig().LMS_BASE_URL}/api/ai_tutor/message/${courseId}/`);

  const response = await getAuthenticatedHttpClient().post(url.href, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  return response.data;
}
